export const QUERY_KEYS = {
    MY_SOLVOOK_HOME: [
        "my-solvook-home"
    ],
    MY_COUPONS: [
        "my-coupons"
    ],
    MY_PASSES: [
        "my-passes"
    ],
    MY_SUBSCRIPTIONS: [
        "my-subscriptions"
    ],
    MY_DEVICES: [
        "my-devices"
    ]
};
